// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__1T1bi","formControl":"addForm_formControl__w5qWA","list":"addForm_list__oZ1SO","btnWrpper":"addForm_btnWrpper__2F7zI"};